<template>
    <div>
        <div class="support-tickets-header">
            <!-- <div class="tickets-filter">
                <div class="form-group mr-3">
                    <label class="d-none d-md-inline-block mr-2">Status</label>
                    <select class="form-control-sm" v-model="selectedStatus" @change="onChange">
                        <option v-for="(status, index) in imageStatusOptions" :value="imageStatus" @change="filterImages()" :selected="index == 0">{{status}}</option>
                    </select>
                </div>
            </div> -->
        </div>
        <div class="support-ticket" v-for="integration in integrations">
            <div class="st-meta">
                <!-- <i class="fas fa-flag flagged" ></i> -->
                <!-- <i class="fas fa-check-circle" v-if="isQCApproved(product) == 1" :class="'qc-'+isQCApproved(product)"></i>
                <i class="fas fa-times-circle" v-if="isQCRejected(product) == 1" :class="'qc-'+isQCRejected(product)"></i> -->
            </div>
            <div class="st-body">
                <div class="col-sm-4">
                    <div class="ticket-content">
                        <h6 class="ticket-title">
                            {{integration.name}}
                        </h6>
                        <div class="ticket-description text-capitalize">
                            {{integration.type}} Level Integration
                        </div>
                        <div class="ticket-description">
                            {{integration.description}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fal fa-check text-success" v-if="integration.is_complete == 1"></i>
                            <i class="fal fa-exclamation-circle text-warning" v-else></i>
                        </div>
                        <div class="label">Attempted</div>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fal fa-check text-success" v-if="integration.is_success == 1"></i>
                            <i class="fal fa-times text-danger" v-else-if="integration.is_success == 0"></i>
                            <i class="fal fa-exclamation-circle text-warning" v-else></i>
                        </div>
                        <div class="label">Response</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <table class="table table-v-compact mb-0">
                        <tbody>
                            <tr>
                                <td>
                                    <strong v-if="integration.notes"> {{integration.notes}}</strong>
                                    <strong v-else> --</strong>
                                    <div class="balance-label smaller lighter text-nowrap">Status</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="st-foot" v-if="integration.is_allow_trigger == 1">
                <a class="btn btn-primary btn-sm" @click="executeAction()">
                    Attempt Now
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  props: ['product', 'integrations'],
  methods: {
    executeAction () {
      var self = this
      const url = '/integrationdesk/bloomingdales/association'

      let data = {
        id_product: self.product.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Integration will be attempted',
            show: true
          })
          self.loadingProduct = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    }
  }
}
</script>

<style>
.support-index .st-foot a.value span {
    border-bottom: none !important;
    color: #000;
    margin-right: 5px;
}
</style>
